module.exports = __webpack_public_path__ + "img/modal-go-to-app.3e52ea47.png";